import React from "react";
import { observer } from "mobx-react";
import { NotificationLevel } from "netbank-shared/src/libs/models/Content/Notification";
import { Notification } from "../Notifications/Notification";

interface IInfoTextProps {
  text: string;
  header?: string;
  className?: string;
  level?: NotificationLevel;
  buttonText?: string;
  buttonAction?: () => void;
}

export const InfoText = observer(({ header, text, level, buttonText, buttonAction }: IInfoTextProps) => {
  return (
    <Notification level={level} header={header} content={text} button={{ title: buttonText, onClick: buttonAction }} />
  );
});
